module.exports = __webpack_public_path__ + "prizes-explore.bd494167.png";